<section class="position-relative animated fadeIn">
  <mat-card appearance="outlined" style="width: 310px; border: 0; margin: 0 auto; padding: 0px 0px;" class="bg-white">
    <mat-card-header class="pt-4 d-flex justify-content-center align-content-center">
      <mat-card-title class="m-0 text-center pb-2 px-3" *ngIf="customImgSrc || customText">
        <img *ngIf="customImgSrc" [src]="customImgSrc | domSanitizer:'url'"
          class="custom-login-img-responsive d-inline-block align-top" [alt]="'LOGIN.LOGOS.CLIENT-ALT' | translate">
        <div *ngIf="customText" class="h4 m-0 pt-2 text-center">
          {{customText}}
        </div>
      </mat-card-title>
      <mat-card-title class="m-0 text-center">
        <img *ngIf="theme === 'Redtrust'" src="assets/images/logo/{{theme}}/logo-color.svg" height="50"
          class="d-inline-block align-top" [alt]="'LOGIN.LOGOS.REDTRUST-ALT' | translate:{ theme: theme }">
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="p-4">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-form-field class="full-width-input w-100">
          <input matInput autocomplete="off" [disableControl]="true" [readonly]="true"
            [placeholder]="'LOGIN.FORM.USERNAME' | translate" formControlName="username">
          <mat-error *ngIf="isFieldInvalid('username')">
            {{ 'LOGIN.FORM.VALIDATOR.REQUIRE.USERNAME' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width-input w-100">
          <input matInput autocomplete="new-password" [placeholder]="'LOGIN.FORM.CURRENT-PASSWORD' | translate"
            formControlName="password" #password [type]="!password.hide ? 'password' : 'text'">
          <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide password" matSuffix
            [attr.data-selenium]="'toggle-login-password'" (click)="password.hide = !password.hide"
            [ngClass]="{'rt-view': !password.hide, 'rt-hide': password.hide}"></i>
          <mat-error *ngIf="isFieldInvalid('password')">
            {{ 'LOGIN.FORM.VALIDATOR.REQUIRE.PASS' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width-input w-100">
          <input matInput autocomplete="new-password" [placeholder]="'LOGIN.FORM.NEW-PASSWORD' | translate"
            formControlName="newPassword" #newPassword [type]="!newPassword.hide ? 'password' : 'text'">
          <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide password" matSuffix
            [attr.data-selenium]="'toggle-login-password'" (click)="newPassword.hide = !newPassword.hide"
            [ngClass]="{'rt-view': !newPassword.hide, 'rt-hide': newPassword.hide}"></i>
          <mat-error *ngIf="isFieldInvalid('newPassword')">
            {{ 'LOGIN.FORM.VALIDATOR.REQUIRE.PASS' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width-input w-100">
          <input matInput [placeholder]="'LOGIN.FORM.CONFIRM-NEW-PASSWORD' | translate"
            formControlName="newPasswordConfirm" #newPasswordConfirm
            [type]="!newPasswordConfirm.hide ? 'password' : 'text'">
          <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide password" matSuffix
            [attr.data-selenium]="'toggle-login-password'" (click)="newPasswordConfirm.hide = !newPasswordConfirm.hide"
            [ngClass]="{'rt-view': !newPasswordConfirm.hide, 'rt-hide': newPasswordConfirm.hide}"></i>
          <mat-error *ngIf="isFieldInvalid('newPasswordConfirm')">
            {{ 'LOGIN.FORM.VALIDATOR.REQUIRE.PASS' | translate }}
          </mat-error>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="form.errors?.fieldsDontMatch">{{
            'LOGIN.FORM.PASSWORD-DONT-MATCH' | translate }}</mat-hint>
        </mat-form-field>
        <button mat-raised-button color="primary" class="w-100 mt-3"
          [disabled]="loadingLogin || !(form.valid) || form.errors?.fieldsDontMatch" type="submit">
          <i class="fas fa-spinner fa-pulse fa-1x" *ngIf="loadingLogin"></i>
          <i class="rt-icon rt-transporte" *ngIf="isMobile && !loadingLogin"></i>
          <span *ngIf="!isMobile && !loadingLogin">{{ 'LOGIN.FORM.CHANGE-PASSWORD-LOGIN' | translate }}</span>
        </button>
        <p class="my-2 w-100 text-center">{{ 'LOGIN.FORM.OR' | translate }}</p>
        <button mat-stroked-button color="primary" class="w-100" type="button" [disabled]="loadingLogin"
          (click)="returnLogin()">
          <i class="fas fa-spinner fa-pulse fa-1x" *ngIf="loadingLogin"></i>
          <i class="rt-icon rt-repeat" *ngIf="isMobile && !loadingLogin"></i>
          <span *ngIf="!isMobile && !loadingLogin">{{ 'LOGIN.FORM.LOGIN-ANOTHER-ACC' | translate }}</span>
        </button>
        <span class="w-100 d-inline-block text-center pt-3">
          <small>{{ 'GLOBAL.PERSONAL-TITLE' | translate }}</small>
        </span>
      </form>
    </mat-card-content>
  </mat-card>
</section>